import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/general/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/general/';

class GeneralService {

  getFieldColors() {
    return axios.get(API_URL+"field-colors");
  }

  getPositions() {
    return axios.get(API_URL+"positions");
  }

  getBaseRadars() {
    return axios.get(API_URL+"base-radars");
  }

  getEventTypes() {
    return axios.get(API_URL+"event-types");
  }

  getStrategies() {
    return axios.get(API_URL+"strategies");
  }

  getFormations() {
    return axios.get(API_URL+"formations");
  }

  getShotDetectionStatus() {
    return axios.get(API_URL+"shot-detection-status");
  }

  getMatchTypes() {
    return axios.get(API_URL+"match-types");
  }

  getMatchGroups() {
    return axios.get(API_URL+"match-groups");
  }

  getRoundTypes() {
    return axios.get(API_URL+"round-types");
  }

  getGameFileTypes() {
    return axios.get(API_URL+"game-file-types");
  }

  getSides() {
    return axios.get(API_URL+"sides");
  }

  getLeagueAreas() {
    return axios.get(API_URL+"league-areas");
  }


}

export default new GeneralService();



// WEBPACK FOOTER //
// ./src/services/general.service.js